import { Link } from 'react-router-dom';
import './ListEmptyStateV2.css';

export function ListPageLoadingV2() {
    return (
        <div className="list-page-v2-loading" role="status" aria-live="polite">
            Loading…
        </div>
    );
}

/**
 * Centered empty state for list pages (orders, invoices, etc.).
 * Uses V2 design tokens (cream background on parent, card panel here).
 */
export default function ListEmptyStateV2({ icon: Icon, title, description, primaryAction, secondaryAction }) {
    return (
        <div className="list-empty-v2-container">
            <div className="list-empty-v2">
                {Icon && (
                    <div className="list-empty-v2__icon" aria-hidden>
                        <Icon />
                    </div>
                )}
                <h2 className="list-empty-v2__title">{title}</h2>
                <p className="list-empty-v2__desc">{description}</p>
                {(primaryAction || secondaryAction) && (
                    <div className="list-empty-v2__actions">
                        {primaryAction?.to && (
                            <Link to={primaryAction.to} className="list-empty-v2__btn list-empty-v2__btn--primary">
                                {primaryAction.label}
                            </Link>
                        )}
                        {primaryAction?.onClick && (
                            <button
                                type="button"
                                className="list-empty-v2__btn list-empty-v2__btn--primary"
                                onClick={primaryAction.onClick}
                            >
                                {primaryAction.label}
                            </button>
                        )}
                        {secondaryAction?.onClick && (
                            <button
                                type="button"
                                className="list-empty-v2__btn list-empty-v2__btn--secondary"
                                onClick={secondaryAction.onClick}
                            >
                                {secondaryAction.label}
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
